
export default [
    // {
    //     path: "/Appraisal/Index",
    //     name: "AppraisalIndex",
    //     component: () => import("@/components/Appraisal/Index.vue"),
    //     meta: {
    //         name: "AppraisalIndex",
    //         menuTitle: "My Data",
    //         requiresAuth: true
    //     },
    //     props: true
    // },
    // {
    //     path: "/Appraisal/Editor",
    //     name: "AppraisalEditor",
    //     component:  () => import("@/components/Appraisal/Editor.vue"),
    //     meta: {
    //         name: "AppraisalEditor",
    //         menuTitle :"My Data",
    //         requiresAuth: true
    //     },
    //     props: true
    // },
    {
        path: "/Dashboard/Index",
        name: "DashboardIndex",
        component: () => import("@/components/Dashboard/Index.vue"),
        meta: {
            name: "DashboardIndex",
            menuTitle: "Dashboard",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Approval/IndexMD",
        name: "ApprovalIndexMD",
        component: () => import("@/components/Approval/IndexMD.vue"),
        meta: {
            name: "ApprovalIndexMD",
            menuTitle: "Approval Master Data",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/MainData/Index",
        name: "MainDataIndex",
        component: () => import("@/components/MainData/Index.vue"),
        meta: {
            name: "MainDataIndex",
            menuTitle: "MainData",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/MainData/Editor",
        name: "MainDataEditor",
        component:  () => import("@/components/MainData/Editor.vue"),
        meta: {
            name: "MainDataEditor",
            menuTitle: "MainData",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaWithSpo/Editor",
        name: "BaWithSpoEditor",
        component:  () => import("@/components/BaWithSpo/Editor.vue"),
        meta: {
            name: "BaWithSpoEditor",
            menuTitle: "BaWithSpo",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaWithSpo/Index",
        name: "BaWithSpoIndex",
        component:  () => import("@/components/BaWithSpo/Index.vue"),
        meta: {
            name: "BaWithSpoIndex",
            menuTitle: "BaWithSpo",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/DocKom/Editor",
        name: "DocKomEditor",
        component:  () => import("@/components/DocKom/Editor.vue"),
        meta: {
            name: "DocKomEditor",
            menuTitle: "DocKom",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/DocKom/Index",
        name: "DocKomIndex",
        component:  () => import("@/components/DocKom/Index.vue"),
        meta: {
            name: "DocKomIndex",
            menuTitle: "DocKom",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaDelay/Editor",
        name: "BaDelayEditor",
        component:  () => import("@/components/BaDelay/Editor.vue"),
        meta: {
            name: "BaDelayEditor",
            menuTitle: "BaDelay",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaDelay/Index",
        name: "BaDelayIndex",
        component:  () => import("@/components/BaDelay/Index.vue"),
        meta: {
            name: "BaDelayIndex",
            menuTitle: "BaDelay",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaPenalty/Editor",
        name: "BaPenaltyEditor",
        component:  () => import("@/components/BaPenalty/Editor.vue"),
        meta: {
            name: "BaPenaltyEditor",
            menuTitle: "BaPenalty",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaPenalty/Index",
        name: "BaPenaltyIndex",
        component:  () => import("@/components/BaPenalty/Index.vue"),
        meta: {
            name: "BaPenaltyIndex",
            menuTitle: "BaPenalty",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaAddendum/Editor",
        name: "BaAddendumEditor",
        component:  () => import("@/components/BaAddendum/Editor.vue"),
        meta: {
            name: "BaAddendumEditor",
            menuTitle: "BaAddendum",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaAddendum/Index",
        name: "BaAddendumIndex",
        component:  () => import("@/components/BaAddendum/Index.vue"),
        meta: {
            name: "BaAddendumIndex",
            menuTitle: "BaAddendum",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaTermin/Editor",
        name: "BaTerminEditor",
        component:  () => import("@/components/BaTermin/Editor.vue"),
        meta: {
            name: "BaTerminEditor",
            menuTitle: "BaTermin",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaTermin/Index",
        name: "BaTerminIndex",
        component:  () => import("@/components/BaTermin/Index.vue"),
        meta: {
            name: "BaTerminIndex",
            menuTitle: "BaTermin",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/QcFinal/Editor",
        name: "QcFinalEditor",
        component:  () => import("@/components/QcFinal/Editor.vue"),
        meta: {
            name: "QcFinalEditor",
            menuTitle: "QcFinal",
            requiresAuth: true
        },
        props: true
    }, 
    {
        path: "/QcFinal/Index",
        name: "QcFinalIndex",
        component:  () => import("@/components/QcFinal/Index.vue"),
        meta: {
            name: "QcFinalIndex",
            menuTitle: "QcFinal",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaFinal/Editor",
        name: "BaFinalEditor",
        component:  () => import("@/components/BaFinal/Editor.vue"),
        meta: {
            name: "BaFinalEditor",
            menuTitle: "BaFinal",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaFinal/Index",
        name: "BaFinalIndex",
        component:  () => import("@/components/BaFinal/Index.vue"),
        meta: {
            name: "BaFinalIndex",
            menuTitle: "BaFinal",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaWithOutSpo/Editor",
        name: "BaWithOutSpoEditor",
        component:  () => import("@/components/BaWithOutSpo/Editor.vue"),
        meta: {
            name: "BaWithOutSpoEditor",
            menuTitle: "BaWithOutSpo",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaWithOutSpo/Index",
        name: "BaWithOutSpoIndex",
        component:  () => import("@/components/BaWithOutSpo/Index.vue"),
        meta: {
            name: "BaWithOutSpoIndex",
            menuTitle: "BaWithOutSpo",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Approval/Index",
        name: "ApprovalIndex",
        component: () => import("@/components/Approval/Index.vue"),
        meta: {
            name: "ApprovalIndex",
            menuTitle: "Approval Transaction",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaTermin/EditorChild",
        name: "BaTerminEditorChild",
        component:  () => import("@/components/BaTermin/EditorChild.vue"),
        meta: {
            name: "BaTerminEditorChild",
            menuTitle: "Duplicate BaTermin",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaRetensi/Index",
        name: "BaRetensiIndex",
        component:  () => import("@/components/BaRetensi/Index.vue"),
        meta: {
            name: "BaRetensiIndex",
            menuTitle: "BaRetensi",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/BaRetensi/Editor",
        name: "BaRetensiEditor",
        component:  () => import("@/components/BaRetensi/Editor.vue"),
        meta: {
            name: "BaRetensiEditor",
            menuTitle: "BaRetensi",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/DocKomQC/Editor",
        name: "DocKomQCEditor",
        component:  () => import("@/components/KomQC/Editor.vue"),
        meta: {
            name: "DocKomQCEditor",
            menuTitle: "Doc Kom QC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/DocKomQC/Index",
        name: "DocKomQcIndex",
        component:  () => import("@/components/KomQC/Index.vue"),
        meta: {
            name: "DocKomQcIndex",
            menuTitle: "Doc Kom QC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/WoRelease/Index",
        name: "WoReleaseIndex",
        component:  () => import("@/components/WoRelease/Index.vue"),
        meta: {
            name: "WoReleaseIndex",
            menuTitle: "WoRelease",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/WoRelease/Editor",
        name: "WoReleaseEditor",
        component:  () => import("@/components/WoRelease/Editor.vue"),
        meta: {
            name: "WoReleaseEditor",
            menuTitle: "WoRelease",
            requiresAuth: true
        },
        props: true
    }, 
    {
        path: "/WoRelease/EditorPIC",
        name: "WoReleaseEditorPIC",
        component:  () => import("@/components/WoRelease/EditorPIC.vue"),
        meta: {
            name: "WoReleaseEditorPIC",
            menuTitle: "WoRelease",
            requiresAuth: true
        },
        props: true
    }, 
    {
        path: "/Approval/IndexWo",
        name: "ApprovalIndexWo",
        component: () => import("@/components/Approval/IndexWo.vue"),
        meta: {
            name: "ApprovalIndexWo",
            menuTitle: "Approval Work Order",
            requiresAuth: true
        },
        props: true
    },

    {
        path: "/WoProgressing/Index",
        name: "WoProgressingIndex",
        component:  () => import("@/components/WoProgressing/Index.vue"),
        meta: {
            name: "WoReleaseIndex",
            menuTitle: "WoProgressing",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/WoProgressing/Editor",
        name: "WoProgressingEditor",
        component:  () => import("@/components/WoProgressing/Editor.vue"),
        meta: {
            name: "WoProgressingEditor",
            menuTitle: "WoProgressing",
            requiresAuth: true
        },
        props: true
    }, 
    {
        path: "/MC/Index",
        name: "MCIndex",
        component:  () => import("@/components/MC/Index.vue"),
        meta: {
            name: "MCIndex",
            menuTitle: "MC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/MC/Editor",
        name: "MCEditor",
        component:  () => import("@/components/MC/Editor.vue"),
        meta: {
            name: "MCEditor",
            menuTitle: "MC",
            requiresAuth: true
        },
        props: true
    }, 
    {
        path: "/AddendumMC/Index",
        name: "AddendumMCIndex",
        component:  () => import("@/components/AddendumMC/Index.vue"),
        meta: {
            name: "AddendumMCIndex",
            menuTitle: "Addendum MC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AddendumMC/EditorBAPVA",
        name: "AddendumMCEditorBAPVA",
        component:  () => import("@/components/AddendumMC/EditorBAPVA.vue"),
        meta: {
            name: "AddendumMCEditorBAPVA",
            menuTitle: "BAPVA MC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AddendumMC/EditorRKTK",
        name: "AddendumMCEditorRKTK",
        component:  () => import("@/components/AddendumMC/EditorRKTK.vue"),
        meta: {
            name: "AddendumMCEditorRKTK",
            menuTitle: "RKTK MC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AddendumMC/EditorAddendum",
        name: "AddendumMCEditorAddendum",
        component:  () => import("@/components/AddendumMC/EditorAddendum.vue"),
        meta: {
            name: "AddendumMCEditorAddendum",
            menuTitle: "Addendum MC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ProgressTermin/Index",
        name: "ProgressTerminIndex",
        component:  () => import("@/components/ProgressTermin/Index.vue"),
        meta: {
            name: "ProgressTerminIndex",
            menuTitle: "Progress Termin",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ProgressTermin/EditorChild",
        name: "ProgressTerminEditorChild",
        component:  () => import("@/components/ProgressTermin/EditorChild.vue"),
        meta: {
            name: "ProgressTerminEditorChild",
            menuTitle: "Duplicate Progress Termin",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ProgressTermin/Editor",
        name: "ProgressTerminEditor",
        component:  () => import("@/components/ProgressTermin/Editor.vue"),
        meta: {
            name: "ProgressTerminEditor",
            menuTitle: "Progress Termin",
            requiresAuth: true
        },
        props: true
    }, 
    {
        path: "/ProgressFinal/Index",
        name: "ProgressFinalIndex",
        component:  () => import("@/components/ProgressFinal/Index.vue"),
        meta: {
            name: "ProgressFinalIndex",
            menuTitle: "Progress Final",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ProgressFinal/Editor",
        name: "ProgressFinalEditor",
        component:  () => import("@/components/ProgressFinal/Editor.vue"),
        meta: {
            name: "ProgressFinalEditor",
            menuTitle: "Progress Final",
            requiresAuth: true
        },
        props: true
    }, 
]